import React, { ChangeEvent, KeyboardEvent, useCallback, useEffect, useState } from 'react'
import styles from '~/styles/molecules/textbox/textbox.module.scss'
import { useOutsideClick } from '~/hooks/ouside'

import { GeneralIconTag } from '~/common/define/icon'
import { addClass } from '~/common/utils/html'
import SupportTextBox from '~/components/atoms/textbox/SupportTextBox'
import Icon, { IconColor, IconFrame, IconSize } from '~/components/atoms/icon/Icon'
import { TextBoxSize } from '~/components/atoms/textbox/TextBox'
import TooltipWrapper from '~/components/wrapper/tooltip/TooltipWrapper'
import IconButton from '~/components/atoms/icon/IconButton'

interface Props {
  onChangeText(text: string): void
  handleSubmit?(text: string): void
  placeholder?: string
  toolTipText?: string
  size?: TextBoxSize
  alwaysActive?: boolean
  close?: boolean
  color?: IconColor
  defaultText?: string
}

const SearchIconTextBox = React.memo(({
                                        onChangeText, handleSubmit, size = TextBoxSize.MIDDLE,
                                        placeholder = '', toolTipText = null, alwaysActive = false,
                                        close = false, color = IconColor.GRAY, defaultText = ''
}: Props) => {
  const [open, setOpen] = useState<boolean>(alwaysActive)
  const [text, setText] = useState<string>(defaultText)

  const ref = useOutsideClick(() => {
    !alwaysActive && setOpen(false)
  }, text.length == 0 && !alwaysActive)

  useEffect(() => {
    close && setOpen(false)
  }, [close])

  const onChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    setText(e.target.value)
    onChangeText(e.target.value)
  }, [])

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.nativeEvent.isComposing || e.key !== 'Enter') return
    handleSubmit(text)
  }

  useEffect(() => {
    setOpen(alwaysActive)
  }, [alwaysActive])

  useEffect(() => {
    setText(defaultText)
  }, [defaultText])

  return (
    <div className={styles.search + addClass(styles.search__spread, size == TextBoxSize.SMALL)}>
      <SupportTextBox value={text} open={open} size={size} onChange={onChange} onKeyDown={handleKeyDown} placeholder={placeholder} inputRef={ref}/>
      <span className={styles.search__icon + addClass(styles.open, open)} onClick={() => {
        setOpen(true)
        ref.current.focus()
      }}>
        <TooltipWrapper text={toolTipText} off={!toolTipText}>
          <IconButton
            tag={GeneralIconTag.SEARCH} size={size == TextBoxSize.SMALL ? IconSize.SMALL : IconSize.M_SMALL}
            frame={IconFrame.CIRCLE}
            frameColor={open ? null : color}
            clickableColor={open ? null :  color}
            onClick={() => handleSubmit(text)}
          />
        </TooltipWrapper>
      </span>
    </div>
  )
})

export default SearchIconTextBox